import React, { ChangeEvent, useCallback } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';

interface MessagesSearchProps {
  onSearchChange: (search: string) => void;
}

export const MessagesSearch = (props: MessagesSearchProps) => {
  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value.trim();
      if (value.length < 3 && value.length !== 0) return;

      props.onSearchChange(value);
    },
    [props.onSearchChange]
  );

  return (
    <InputGroup className='msg_search_group'>
      <InputGroup.Text className='bg-transparent msg_search-icon'>
        <i className='fa-light fa-magnifying-glass text-primary'></i>
      </InputGroup.Text>
      <FormControl
        aria-label='Messages'
        aria-describedby='basic-addon1'
        className='search_input'
        maxLength={30}
        onChange={onChange}
        placeholder='Search Messages'
      />
    </InputGroup>
  );
};
